(function () {
  "use strict";

  if (window.AoneContactForm && window.AoneContactForm.__assetLoaded) {
    window.AoneContactForm.init(document);
    return;
  }

  var DEFAULT_ENDPOINT = "/apps/aone-api/contact/submit";
  var REQUEST_TIMEOUT_MS = 20000;
  var SUCCESS_MESSAGE = "Your message has been sent successfully.";
  var TIMEOUT_MESSAGE = "The request took too long. Please try again.";
  var FALLBACK_ERROR_MESSAGE = "We could not send your message right now. Please try again later.";
  var ALLOWED_DEPARTMENTS = new Set(["accounts", "sales", "marketing", "it_support", "purchase"]);

  function toTrimmedString(value) {
    return String(value || "").trim();
  }

  function readNamedControl(form, name) {
    var control = form.elements.namedItem(name);
    if (!control) return null;
    if (typeof RadioNodeList !== "undefined" && control instanceof RadioNodeList) {
      return control[0] || null;
    }
    return control;
  }

  function safeAddDescribedBy(control, id) {
    if (!control || !id) return;
    var current = toTrimmedString(control.getAttribute("aria-describedby"));
    if (current === "") {
      control.setAttribute("aria-describedby", id);
      return;
    }
    var parts = current.split(/\s+/).filter(Boolean);
    if (parts.indexOf(id) === -1) {
      parts.push(id);
      control.setAttribute("aria-describedby", parts.join(" "));
    }
  }

  function safeRemoveDescribedBy(control, id) {
    if (!control || !id) return;
    var current = toTrimmedString(control.getAttribute("aria-describedby"));
    if (current === "") return;
    var parts = current.split(/\s+/).filter(function (part) {
      return part && part !== id;
    });
    if (parts.length > 0) {
      control.setAttribute("aria-describedby", parts.join(" "));
    } else {
      control.removeAttribute("aria-describedby");
    }
  }

  function findNodeByIdWithin(form, id) {
    if (!id) return null;
    var node = document.getElementById(id);
    if (!node) return null;
    return form.contains(node) ? node : null;
  }

  function ContactFormController(root, form) {
    this.root = root;
    this.form = form;
    this.endpoint = toTrimmedString(form.getAttribute("data-contact-endpoint")) || DEFAULT_ENDPOINT;
    this.submitButton = form.querySelector("[data-contact-submit]");
    this.submitTextNode = form.querySelector("[data-contact-submit-text]");
    this.statusNode = form.querySelector("[data-contact-status]");
    this.departmentSelect = form.querySelector("[data-contact-department-select]");
    this.departmentCards = Array.prototype.slice.call(
      root.querySelectorAll("[data-contact-department-card][data-department]")
    );
    this.routingPreview = root.querySelector("[data-aone-contact-routing-preview]");
    this.isSubmitting = false;
    this.activeAbortController = null;
    this.timeoutHandle = null;
    this.originalSubmitText = this.submitTextNode ? this.submitTextNode.textContent : "";

    this.onSubmit = this.onSubmit.bind(this);
    this.onDepartmentSelectChange = this.onDepartmentSelectChange.bind(this);
    this.onDepartmentCardClick = this.onDepartmentCardClick.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onInvalid = this.onInvalid.bind(this);

    this.form.addEventListener("submit", this.onSubmit);
    this.form.addEventListener("input", this.onInput);
    this.form.addEventListener("change", this.onInput);
    this.form.addEventListener("invalid", this.onInvalid, true);

    if (this.departmentSelect) {
      this.departmentSelect.addEventListener("change", this.onDepartmentSelectChange);
    }

    for (var i = 0; i < this.departmentCards.length; i += 1) {
      this.departmentCards[i].addEventListener("click", this.onDepartmentCardClick);
    }

    this.syncDepartmentCardsFromSelect();
  }

  ContactFormController.prototype.onInput = function (event) {
    var target = event.target;
    if (!target || !target.name) return;
    this.clearFieldError(target.name);
  };

  ContactFormController.prototype.onInvalid = function (event) {
    var target = event.target;
    if (!target || !target.name) return;
    target.classList.add("is-invalid");
    target.setAttribute("aria-invalid", "true");
  };

  ContactFormController.prototype.onDepartmentCardClick = function (event) {
    if (!this.departmentSelect) return;
    var button = event.currentTarget;
    var department = toTrimmedString(button.getAttribute("data-department"));
    if (!ALLOWED_DEPARTMENTS.has(department)) return;
    if (this.departmentSelect.value === department) {
      this.departmentSelect.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
    this.departmentSelect.value = department;
    this.departmentSelect.dispatchEvent(new Event("change", { bubbles: true }));
  };

  ContactFormController.prototype.syncDepartmentCardsFromSelect = function () {
    var selectedValue = this.departmentSelect ? toTrimmedString(this.departmentSelect.value) : "";
    for (var i = 0; i < this.departmentCards.length; i += 1) {
      var card = this.departmentCards[i];
      var cardDepartment = toTrimmedString(card.getAttribute("data-department"));
      var isSelected = selectedValue !== "" && cardDepartment === selectedValue;
      card.classList.toggle("is-selected", isSelected);
      card.setAttribute("aria-pressed", isSelected ? "true" : "false");
    }

    if (!this.routingPreview) return;
    if (selectedValue === "") {
      this.routingPreview.textContent = "";
      this.routingPreview.classList.add("is-empty");
      return;
    }

    var selectedOption = this.departmentSelect.options[this.departmentSelect.selectedIndex];
    var selectedLabel = selectedOption ? toTrimmedString(selectedOption.textContent) : "";
    var prefix = toTrimmedString(this.routingPreview.getAttribute("data-routing-prefix"));
    if (selectedLabel === "") {
      this.routingPreview.textContent = "";
      this.routingPreview.classList.add("is-empty");
      return;
    }
    this.routingPreview.textContent = prefix ? prefix + " " + selectedLabel : selectedLabel;
    this.routingPreview.classList.remove("is-empty");
  };

  ContactFormController.prototype.onDepartmentSelectChange = function () {
    this.syncDepartmentCardsFromSelect();
    this.clearFieldError("department");
  };

  ContactFormController.prototype.setStatus = function (status, message) {
    if (!this.statusNode) return;
    this.statusNode.setAttribute("data-status", status);
    this.statusNode.textContent = toTrimmedString(message);
  };

  ContactFormController.prototype.clearStatus = function () {
    if (!this.statusNode) return;
    this.statusNode.removeAttribute("data-status");
    this.statusNode.textContent = "";
  };

  ContactFormController.prototype.setSubmittingState = function (isSubmitting) {
    this.isSubmitting = isSubmitting;
    if (!this.submitButton) return;
    this.submitButton.disabled = isSubmitting;
    this.submitButton.setAttribute("aria-busy", isSubmitting ? "true" : "false");
    if (!this.submitTextNode) return;
    this.submitTextNode.textContent = isSubmitting ? "Sending..." : this.originalSubmitText;
  };

  ContactFormController.prototype.resetFieldError = function (control) {
    if (!control) return;
    control.classList.remove("is-invalid");
    control.removeAttribute("aria-invalid");
    var errorId = toTrimmedString(control.getAttribute("data-contact-error-id"));
    if (!errorId) return;
    var errorNode = findNodeByIdWithin(this.form, errorId);
    if (errorNode) {
      errorNode.remove();
    }
    safeRemoveDescribedBy(control, errorId);
    control.removeAttribute("data-contact-error-id");
  };

  ContactFormController.prototype.clearFieldError = function (fieldName) {
    var control = readNamedControl(this.form, fieldName);
    if (!control) return;
    this.resetFieldError(control);
  };

  ContactFormController.prototype.clearAllFieldErrors = function () {
    var fields = this.form.querySelectorAll("input[name], select[name], textarea[name]");
    for (var i = 0; i < fields.length; i += 1) {
      this.resetFieldError(fields[i]);
    }
  };

  ContactFormController.prototype.setFieldError = function (fieldName, message) {
    var safeMessage = toTrimmedString(message);
    var control = readNamedControl(this.form, fieldName);
    if (!control || safeMessage === "") return;

    var baseId = control.id ? control.id : this.form.id + "-" + fieldName;
    var errorId = baseId + "-error";
    var errorNode = findNodeByIdWithin(this.form, errorId);
    if (!errorNode) {
      errorNode = document.createElement("p");
      errorNode.className = this.root.className.split(" ")[0] + "__field-error";
      errorNode.id = errorId;
      errorNode.setAttribute("data-contact-field-error", "true");
      control.insertAdjacentElement("afterend", errorNode);
    }

    errorNode.textContent = safeMessage;
    control.classList.add("is-invalid");
    control.setAttribute("aria-invalid", "true");
    control.setAttribute("data-contact-error-id", errorId);
    safeAddDescribedBy(control, errorId);
  };

  ContactFormController.prototype.buildPayload = function () {
    var formData = new FormData(this.form);
    return {
      fullName: toTrimmedString(formData.get("fullName")),
      email: toTrimmedString(formData.get("email")),
      phone: toTrimmedString(formData.get("phone")),
      department: toTrimmedString(formData.get("department")),
      message: toTrimmedString(formData.get("message")),
      website: toTrimmedString(formData.get("website"))
    };
  };

  ContactFormController.prototype.abortInFlight = function () {
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }
    if (this.activeAbortController) {
      this.activeAbortController.abort();
      this.activeAbortController = null;
    }
  };

  ContactFormController.prototype.parseResponse = async function (response) {
    var text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  };

  ContactFormController.prototype.onSubmit = async function (event) {
    event.preventDefault();
    if (this.isSubmitting) return;

    this.clearStatus();
    this.clearAllFieldErrors();

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    var payload = this.buildPayload();
    if (!ALLOWED_DEPARTMENTS.has(payload.department)) {
      this.setFieldError("department", "Please select a valid department.");
      if (this.departmentSelect) {
        this.departmentSelect.focus();
      }
      this.setStatus("error", "Please select a valid department.");
      return;
    }

    var controller = new AbortController();
    this.activeAbortController = controller;
    this.timeoutHandle = window.setTimeout(function () {
      controller.abort();
    }, REQUEST_TIMEOUT_MS);

    this.setSubmittingState(true);
    // Keep loading feedback on the submit button only — do not mirror "Sending..." in the status line.

    try {
      var response = await fetch(this.endpoint || DEFAULT_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify(payload),
        signal: controller.signal
      });

      if (this.timeoutHandle) {
        clearTimeout(this.timeoutHandle);
        this.timeoutHandle = null;
      }
      this.activeAbortController = null;

      var data = await this.parseResponse(response);
      if (!response.ok || !data || data.success !== true) {
        var backendMessage = data && typeof data.message === "string" ? toTrimmedString(data.message) : "";
        var safeMessage = backendMessage || FALLBACK_ERROR_MESSAGE;
        this.setStatus("error", safeMessage);

        if (response.status === 422 && data && data.errors && typeof data.errors === "object") {
          var firstInvalid = null;
          var fieldNames = Object.keys(data.errors);
          for (var i = 0; i < fieldNames.length; i += 1) {
            var fieldName = fieldNames[i];
            var fieldMessage = toTrimmedString(data.errors[fieldName]);
            if (!fieldMessage) continue;
            this.setFieldError(fieldName, fieldMessage);
            if (!firstInvalid) {
              firstInvalid = readNamedControl(this.form, fieldName);
            }
          }
          if (firstInvalid) {
            firstInvalid.focus();
          } else if (this.statusNode) {
            this.statusNode.focus();
          }
        } else if (this.statusNode) {
          this.statusNode.focus();
        }
        return;
      }

      var successMessage = toTrimmedString(data.message) || SUCCESS_MESSAGE;
      var referenceId =
        data &&
        data.data &&
        typeof data.data.referenceId === "string" &&
        toTrimmedString(data.data.referenceId) !== ""
          ? toTrimmedString(data.data.referenceId)
          : "";
      if (referenceId) {
        successMessage = successMessage + "\nReference ID: " + referenceId;
      }
      this.setStatus("success", successMessage);
      this.form.reset();
      this.clearAllFieldErrors();
      this.syncDepartmentCardsFromSelect();
      if (this.statusNode) {
        this.statusNode.focus();
      }
    } catch (error) {
      if (this.timeoutHandle) {
        clearTimeout(this.timeoutHandle);
        this.timeoutHandle = null;
      }
      this.activeAbortController = null;
      var isTimeout = error && error.name === "AbortError";
      this.setStatus("error", isTimeout ? TIMEOUT_MESSAGE : FALLBACK_ERROR_MESSAGE);
      if (this.statusNode) {
        this.statusNode.focus();
      }
      if (!isTimeout && typeof console !== "undefined" && typeof console.error === "function") {
        console.error("A-One contact form request failed.");
      }
    } finally {
      this.setSubmittingState(false);
    }
  };

  var controllers = new WeakMap();

  function initForms(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var forms = root.querySelectorAll("[data-contact-form]");
    for (var i = 0; i < forms.length; i += 1) {
      var form = forms[i];
      if (form.dataset.contactInitialized === "true") continue;
      var formRoot = form.closest("[data-contact-root]");
      if (!formRoot) continue;
      form.dataset.contactInitialized = "true";
      controllers.set(form, new ContactFormController(formRoot, form));
    }
  }

  function onSectionLoad(event) {
    var target = event && event.target ? event.target : document;
    initForms(target);
  }

  function boot() {
    initForms(document);
    document.addEventListener("shopify:section:load", onSectionLoad);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.AoneContactForm = {
    __assetLoaded: true,
    init: initForms
  };
})();
